import { FieldError, Label } from 'react-aria-components';
import { FillClockIcon } from '@shared/assets/icons/shared/fill-clock-icon';
import {
  DateInput,
  TimeField as CustomTimeField,
} from '@src/design-system/datepicker';
import type { ComponentProps, ReactNode } from 'react';

export function TimeField({
  prefexIcon,
  label = 'Time',
  ...props
}: ComponentProps<typeof CustomTimeField> & {
  prefexIcon?: ReactNode;
  label?: string;
}) {
  return (
    <CustomTimeField {...props}>
      <Label className='text-sm mb-3 font-medium inline-block text-gray-800 leading-none'>
        {label}
      </Label>
      <div className='relative'>
        <div className='text-gray-500 pointer-events-none absolute inset-y-0 start-0 z-10 flex items-center justify-center ps-3'>
          {prefexIcon ?? <FillClockIcon />}
        </div>
        <DateInput className='ps-9' />
      </div>

      <FieldError className='text-xs text-destructive' />
    </CustomTimeField>
  );
}
